// Helper function to detect touch devices.
function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

let tooltipCount = 0;

class VgTooltip extends HTMLElement {
	connectedCallback() {
		this.setup();
		this.setupAria();
	}

	setupAria() {
		if (!this.placeholder || !this.dropdown) return;

		if (!this.dropdown.id) {
			this.dropdown.id = `vg-tooltip-${++tooltipCount}`;
		}
		this.dropdown.setAttribute('role', 'tooltip');
		this.placeholder.setAttribute('aria-describedby', this.dropdown.id);
	}

	handleDropdownPosition() {
		const placeholderRect = this.placeholder.getBoundingClientRect();
		const dropdownRect = this.dropdown.getBoundingClientRect();

		const dropdownRightX = dropdownRect.x + dropdownRect.width;
		const placeholderRightX = placeholderRect.x + placeholderRect.width;
		const screenPadding = 10;
		
		const isMobile = window.innerWidth <= 768;
		
		if (isMobile) {
			setTimeout(() => {
				const panelHeight = this.dropdown.scrollHeight;
				const viewportHeight = window.innerHeight;
				
				if (panelHeight > viewportHeight - 100) {
					this.dropdown.classList.add('vg-tooltip__panel--tall');
				} else {
					this.dropdown.classList.remove('vg-tooltip__panel--tall');
				}
			}, 0);
		} else {
			if( (dropdownRect.x + dropdownRect.width) > window.innerWidth ) {
				this.dropdown.style.left = "auto";
				this.dropdown.style.right = "0";
				this.dropdown.style.transform = `translateX(${
					window.innerWidth - placeholderRightX - screenPadding
				}px)`;
			}

			if( (placeholderRect.y - dropdownRect.height) < 0 ) {
				this.dropdown.style.bottom = "auto";
				this.dropdown.style.top = placeholderRect.height + 5 + "px";
			}else{
				this.dropdown.style.top = "auto";
				this.dropdown.style.bottom = placeholderRect.height + 5 + "px";
			}
		}
	}

	toggle() {
		if (this.isOpen()) {
			this.close();
		} else {
			this.open();
		}
	}

	isOpen() {
		return this.getAttribute("data-open") === "true";
	}

	open() {
		// Don't open tooltip visually on touch devices (mobile and tablet).
		if (isTouchDevice()) {
			return;
		}
		this.setAttribute("data-open", "true");
		this.handleDropdownPosition();
	}

	close() {
		this.removeAttribute("data-open");
	}

	setup() {
		this.placeholder = this.querySelector(".vg-tooltip__trigger");
		this.dropdown = this.querySelector(".vg-tooltip__panel");
		this.touchHandled = false;
		this.lastTouchTime = 0;

		this.placeholder.addEventListener("mouseover", () => {
			document.dispatchEvent(new CustomEvent("vg-tooltip-hover", { detail: { content: this.dropdown } }, {passive: true} ));
			this.handleDropdownPosition();
		});
		this.placeholder.addEventListener("touchstart", (e) => {
			const now = Date.now();
			
			// Mark that touch was handled to prevent subsequent click event.
			this.touchHandled = true;
			this.lastTouchTime = now;
			
			// On touch devices, don't open the visual tooltip, only dispatch the event for the modal.
			if (!isTouchDevice()) {
				this.toggle();
			} else {
				// Ensure tooltip is closed on touch devices.
				this.close();
			}
			
			// Dispatch event asynchronously to avoid conflicts with dismissAllTooltips.
			setTimeout(() => {
				document.dispatchEvent(new CustomEvent("vg-tooltip-click", { detail: { content: this.dropdown } }));
			}, 50);
		}, { passive: true });
		this.placeholder.addEventListener("touchend", (e) => {
			// Prevent touchend from propagating and causing a click event.
			e.preventDefault();
		}, { passive: false });
		this.placeholder.addEventListener("click", (e) => {
			const now = Date.now();
			// Prevent click if touch happened recently (less than 500ms ago).
			if (this.touchHandled || (now - this.lastTouchTime < 500)) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return;
			}
			// Only dispatch on desktop or if there's no touch.
			document.dispatchEvent(new CustomEvent("vg-tooltip-click", { detail: { content: this.dropdown } }));
		}, true); // Use capture phase to intercept before other listeners.
	}
}

function dismissAllTooltips(event) {
	if (typeof event.target.closest !== "function") return;
	const currentTooltip = event.target.closest("vg-tooltip");

	document
		.querySelectorAll('vg-tooltip[data-open="true"]')
		.forEach((tooltip) => {
			if (tooltip === currentTooltip) return;
			tooltip.close();
		});
}

customElements.define("vg-tooltip", VgTooltip);
document.addEventListener("touchstart", (e) => dismissAllTooltips(e), {passive: true});
